import { render } from "./GameButtonContainer.vue?vue&type=template&id=0ba8bf77&scoped=true"
import script from "./GameButtonContainer.vue?vue&type=script&lang=js"
export * from "./GameButtonContainer.vue?vue&type=script&lang=js"

import "./GameButtonContainer.vue?vue&type=style&index=0&id=0ba8bf77&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ba8bf77"]])

export default __exports__